module.exports = __webpack_public_path__ + "static/insurance-payment-mobile-5b254170447a9c66b4492b728250f4b3.pdf";